export default {
  namespaced: true,
  state: {
    _id: null,
    nameZH: '',
    nameEN: '',
    privileges: '',
    token: '',
    worksite: '',
    worksiteName: '',
    roles: [],
    sideRight: [],
    employeeCode: '',
    exWorksites: [],
    waterAccountRight: true
  },
  mutations: {
    update(state, payload) {
      state._id = payload.user._id;
      state.nameZH = payload.user.nameZH;
      state.nameEN = payload.user.nameEN;
      state.privileges = payload.user.privileges;
      state.token = payload.user.token;
      state.worksite = payload.user.worksite;
      state.worksiteName = payload.user.worksiteName;
      state.roles = payload.user.roles;
      state.sideRight = payload.user.sideRight;
      state.employeeCode = payload.user.employeeCode;
      state.exWorksites = payload.user.exWorksites;
      state.waterAccountRight = payload.user.waterAccountRight;
    }
  },
  getters: {
    role(state) {
      let roleArray = state.roles;
      if (!roleArray || roleArray.length == 0) {
        return "未知用户类型";
      } else {
        return roleArray.join(',');
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/userInfo/index.js